module.exports = __webpack_public_path__ + "static/media/yacht.eb1efcf5.svg";